import FrontOffice from 'features/frontoffice/index';
import NewHome from 'features/landing/home/newhome';
import AdminNavigator from '../features/admin/navigation/adminNavigator';
import TenantAdminTable from '../features/admin/tenantAdmin/tenantAdminTable';
import TenantManagement from '../features/admin/tenantManagement/tenantManagement';
import VendorLabelingTable from '../features/admin/vendor-labeling/index';
import WhiteLabelingManagement from '../features/admin/white-labeling/index';
import ActivationEngineNavigator from '../features/activationEngine/activationEngineNavigator';
import ClientPortalNavigator from '../features/clientPortal/clientPortalNavigator';
import ClientPortalQuestionary from '../features/clientPortal/components/clientPortalQuestionary';
import ReportDefaultSetting from '../features/frontoffice/defaultSetting';
import Login from '../features/login/login';
import Logout from '../features/logout/logout';
import LookupTableNav from '../features/masterData/components/lookup/lookupTableNav';
import Master from '../features/masterData/master';
import SSO from '../features/sso/ssoRedirect';
import TenantRefreshDataNavigator from '../features/tenantRefresh/tenantRefreshDataAdminNavigator';
import TenantTable from '../features/user/components/tenantTable';
import routePaths from './routePaths';

const routes = {
  newHome: {
    title: 'Home',
    path: routePaths.newHome,
    component: NewHome
  },
  frontOffice: {
    title: 'Home',
    path: routePaths.newHome,
    component: NewHome
  },
  login: {
    title: 'Login',
    path: routePaths.login,
    component: Login
  },
  master: {
    title: 'Master Portal',
    path: routePaths.master,
    component: Master
  },
  lookup: {
    title: 'Lookup Tables',
    path: routePaths.lookup,
    component: LookupTableNav
  },
  adminPage: {
    title: 'Admin',
    path: routePaths.adminPage,
    component: AdminNavigator
  },
  clientTable: {
    title: 'Client Table',
    path: routePaths.clientTable,
    component: TenantTable
  },
  logout: {
    title: 'Logout',
    path: routePaths.logout,
    component: Logout
  },
  whiteLabeling: {
    title: 'Logo Management',
    path: routePaths.whiteLabeling,
    component: WhiteLabelingManagement
  },
  vendorLabeling: {
    title: 'Vendor Logo Management',
    path: routePaths.vendorLabeling,
    component: VendorLabelingTable
  },
  tenantAdmin: {
    title: 'Tenant Admin',
    path: routePaths.tenantAdmin,
    component: TenantAdminTable
  },
  tenantManagement: {
    title: 'Tenant Management',
    path: routePaths.tenantManagement,
    component: TenantManagement
  },
  tenantRefresh: {
    title: 'Refresh Status',
    path: routePaths.tenantRefresh,
    component: TenantRefreshDataNavigator
  },
  clientPortal: {
    title: 'Client Portal',
    path: routePaths.clientPortal,
    component: ClientPortalNavigator
  },
  clientPortalQuestionary: {
    title: 'Client Portal Questionary',
    path: routePaths.clientPortalQuestionary,
    component: ClientPortalQuestionary
  },
  activationEngine: {
    title: 'Activate',
    path: routePaths.activationEngine,
    component: ActivationEngineNavigator
  },
  reportDefaultSetting: {
    title: 'Home',
    path: routePaths.reportDefaultSetting,
    component: ReportDefaultSetting
  },
  oktaSso: {
    title: 'SSO',
    path: routePaths.oktaSso,
    component: SSO
  }
};

export default routes;